import { ContinuingEducationCourse } from './continuingEducationCourse'
import { FeathersModel } from './feathersModel'
import { User } from './user'
import { Assistant } from './assistant'
import { OaCoordinator } from './oaCoordinator'

export class Worker extends FeathersModel {
  static serviceName = 'workers'
  userId: string
  hasTrainingAsWorkerInSocialServices: boolean
  hasTrainingAsSocialWorker: boolean
  user: User
  assistant?: Assistant
  oaCoordinator?: OaCoordinator

  continuingEducationCourses: ContinuingEducationCourse[]

  turnSubresourcesIntoFrontendModels() {
    this.user = this.user ? User.createFromProps(User, this.user) : this.user
  }
}
